import {createAction} from '@reduxjs/toolkit';
import {GetBeersDTO} from 'typescript/dto/beersDto';
import {CreatePubBeerDTO} from 'typescript/dto/createPubBeerDto';
import {EditPubBeerDTO} from 'typescript/dto/editPubBeerDTO';
import {IAdminPubBeersDTO} from 'typescript/dto/getAdminPubBeersDTO';
import {RemovePubBeerDTO} from 'typescript/dto/removePubBeerDto';
import {ReorderPubBeerDTO} from 'typescript/dto/reorderPubBeerDto';
import {ToggleBeerOnTapDto} from 'typescript/dto/toggleBeerOnTapDto';
import {withPayloadType} from 'typescript/types/PayloadType';

import {beersManagerNamespace} from './slice';

const getPubBeersACS = createAction(
  `${beersManagerNamespace}/getPubBeersACS`,
  withPayloadType<{pubId: string; perPage?: number; page?: number}>(),
);
const createPubBeerACS = createAction(`${beersManagerNamespace}/createPubBeerACS`, withPayloadType<CreatePubBeerDTO>());
const deletePubBeerACS = createAction(`${beersManagerNamespace}/deletePubBeerACS`, withPayloadType<RemovePubBeerDTO>());
const getAllBeersACS = createAction(`${beersManagerNamespace}/getAllBeersACS`, withPayloadType<GetBeersDTO>());
const changePubBeerPositionACS = createAction(
  `${beersManagerNamespace}/changePubBeerPositionACS`,
  withPayloadType<ReorderPubBeerDTO>(),
);

const toggleBeerOnTapACS = createAction(
  `${beersManagerNamespace}/toggleBeerOnTapACS`,
  withPayloadType<ToggleBeerOnTapDto>(),
);

const getAdminBeersOnTapACS = createAction(
  `${beersManagerNamespace}/getAdminBeersOnTapACS`,
  withPayloadType<IAdminPubBeersDTO>(),
);

const editPubBeerACS = createAction(`${beersManagerNamespace}/editPubBeerACS`, withPayloadType<EditPubBeerDTO>());

export {
  getAdminBeersOnTapACS,
  getPubBeersACS,
  toggleBeerOnTapACS,
  deletePubBeerACS,
  getAllBeersACS,
  changePubBeerPositionACS,
  createPubBeerACS,
  editPubBeerACS,
};
